import {
    lazyRegisterBeforeUnloadHandlerProxy,
    lazyRegisterOnLoadHandlerProxy,
} from 'owa-metaos-app-bootstrap/lib/lazyAppBoot';

export const registerMetaOsAppHandlers = (
    onLoad?: () => void,
    onBeforeUnload?: () => void
): void => {
    lazyRegisterOnLoadHandlerProxy.importAndExecute(
        onLoad ? { key: 'setMetaOsState', handler: onLoad } : undefined
    );
    lazyRegisterBeforeUnloadHandlerProxy.importAndExecute(
        onBeforeUnload
            ? {
                  key: 'setMetaOsState',
                  handler: onBeforeUnload,
              }
            : undefined
    );
};
